import React from "react";
import { PageFooterHyperlink } from "./page-footer-hyperlink";

export const PageFooter = () => {
  const resourceList = [
    {
      URL: "https://fjelldigital.no/artikler/personvern",
      label: "Personvern",
    },
    {
      URL: "https://fjelldigital.no/#contact",
      label: "Støtte",
    },
  ];

  return (
    <footer className="page-footer">
      <div className="page-footer-grid">
        <div className="page-footer-grid__info">
          <div className="page-footer-info__resource-list">
            {resourceList.map((resource) => (
              <div
                key={resource.URL}
                className="page-footer-info__resource-list-item"
              >
                <PageFooterHyperlink path={resource.URL}>
                  {resource.label}
                </PageFooterHyperlink>
              </div>
            ))}
          </div>
        </div>
        <div className="page-footer-grid__brand">
          <div className="page-footer-brand">
            <img
              className="page-footer-brand__logo"
              src="https://imagedelivery.net/cQwdhF-H4tUVK8IxRhv2kQ/91922b1e-c11d-48bd-dfa4-32a7f65cb000/public"
              alt="Fjell Digital"
              width="auto"
              height="15"
            />
            <PageFooterHyperlink path="https://fjelldigital.no/">
              ©Fjell Digital AS 2025
            </PageFooterHyperlink>
          </div>
        </div>
      </div>
    </footer>
  );
};
